export default __webpack_public_path__ + "static/media/HSL_jatkuva_saasto_tilaus_14.1.2021.473ec69d.pdf";